var map = {
	"../app/accounting/accounting.module": [
		"./src/app/accounting/accounting.module.ts",
		"app-accounting-accounting-module"
	],
	"../app/applicationportfolio/applicationportfolio.module": [
		"./src/app/applicationportfolio/applicationportfolio.module.ts",
		"app-applicationportfolio-applicationportfolio-module"
	],
	"../app/applications/applications.module": [
		"./src/app/applications/applications.module.ts",
		"app-applications-applications-module"
	],
	"../app/backend/backend.module": [
		"./src/app/backend/backend.module.ts",
		"app-backend-backend-module"
	],
	"../app/change-password/change-password.module": [
		"./src/app/change-password/change-password.module.ts",
		"app-change-password-change-password-module"
	],
	"../app/chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"app-chat-chat-module"
	],
	"../app/cooperatives/cooperatives.module": [
		"./src/app/cooperatives/cooperatives.module.ts",
		"app-cooperatives-cooperatives-module"
	],
	"../app/crm/crm.module": [
		"./src/app/crm/crm.module.ts",
		"app-crm-crm-module"
	],
	"../app/customersavings/customersavings.module": [
		"./src/app/customersavings/customersavings.module.ts",
		"app-customersavings-customersavings-module"
	],
	"../app/decision/decision.module": [
		"./src/app/decision/decision.module.ts",
		"app-decision-decision-module"
	],
	"../app/finance/finance.module": [
		"./src/app/finance/finance.module.ts",
		"app-finance-finance-module"
	],
	"../app/investment/investment.module": [
		"./src/app/investment/investment.module.ts",
		"app-investment-investment-module"
	],
	"../app/investmentproducts/investmentproducts.module": [
		"./src/app/investmentproducts/investmentproducts.module.ts",
		"app-investmentproducts-investmentproducts-module"
	],
	"../app/investments/investments.module": [
		"./src/app/investments/investments.module.ts",
		"app-investments-investments-module"
	],
	"../app/investors/investors.module": [
		"./src/app/investors/investors.module.ts",
		"app-investors-investors-module"
	],
	"../app/invproducts/invproducts.module": [
		"./src/app/invproducts/invproducts.module.ts",
		"app-invproducts-invproducts-module"
	],
	"../app/kyc/kyc.module": [
		"./src/app/kyc/kyc.module.ts",
		"app-kyc-kyc-module"
	],
	"../app/loan/loan.module": [
		"./src/app/loan/loan.module.ts",
		"app-loan-loan-module"
	],
	"../app/loanapplications/loanapplications.module": [
		"./src/app/loanapplications/loanapplications.module.ts",
		"app-loanapplications-loanapplications-module"
	],
	"../app/loanproducts/loanproducts.module": [
		"./src/app/loanproducts/loanproducts.module.ts",
		"app-loanproducts-loanproducts-module"
	],
	"../app/marketplace/marketplace.module": [
		"./src/app/marketplace/marketplace.module.ts",
		"app-marketplace-marketplace-module"
	],
	"../app/merchanttransfers/merchanttransfers.module": [
		"./src/app/merchanttransfers/merchanttransfers.module.ts",
		"app-merchanttransfers-merchanttransfers-module"
	],
	"../app/messages/messages.module": [
		"./src/app/messages/messages.module.ts",
		"app-messages-messages-module"
	],
	"../app/mobile/mobile.module": [
		"./src/app/mobile/mobile.module.ts",
		"app-mobile-mobile-module"
	],
	"../app/onboarding/onboarding.module": [
		"./src/app/onboarding/onboarding.module.ts",
		"app-onboarding-onboarding-module"
	],
	"../app/operations/operations.module": [
		"./src/app/operations/operations.module.ts",
		"app-operations-operations-module"
	],
	"../app/people/people.module": [
		"./src/app/people/people.module.ts",
		"app-people-people-module"
	],
	"../app/pickup/pickup.module": [
		"./src/app/pickup/pickup.module.ts",
		"app-pickup-pickup-module"
	],
	"../app/product/product.module": [
		"./src/app/product/product.module.ts",
		"product-product-module"
	],
	"../app/products/products.module": [
		"./src/app/products/products.module.ts",
		"app-products-products-module"
	],
	"../app/reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"app-reports-reports-module"
	],
	"../app/requests/requests.module": [
		"./src/app/requests/requests.module.ts",
		"app-requests-requests-module"
	],
	"../app/saving/saving.module": [
		"./src/app/saving/saving.module.ts",
		"app-saving-saving-module"
	],
	"../app/savingsrequests/savingsrequests.module": [
		"./src/app/savingsrequests/savingsrequests.module.ts",
		"app-savingsrequests-savingsrequests-module"
	],
	"../app/security/security.module": [
		"./src/app/security/security.module.ts",
		"app-security-security-module"
	],
	"../app/serviced/serviced.module": [
		"./src/app/serviced/serviced.module.ts",
		"app-serviced-serviced-module"
	],
	"../app/setting-module/setting-module.module": [
		"./src/app/setting-module/setting-module.module.ts",
		"app-setting-module-setting-module-module"
	],
	"../app/settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"app-settings-settings-module"
	],
	"../app/statement/statement.module": [
		"./src/app/statement/statement.module.ts",
		"app-statement-statement-module"
	],
	"../app/treasury/treasury.module": [
		"./src/app/treasury/treasury.module.ts",
		"app-treasury-treasury-module"
	],
	"../app/web/web.module": [
		"./src/app/web/web.module.ts",
		"app-web-web-module"
	],
	"../product/product.module": [
		"./src/app/product/product.module.ts",
		"product-product-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;